import { Slide, toast } from 'react-toastify';

const SAVED_TOAST_AUTOCLOSE_MS = 3000;

const toastOptions = (containerId: string) => ({
    containerId,
    position: 'bottom-right' as const,
    transition: Slide,
    hideProgressBar: true,
    closeButton: false as const,
});

export const showFlowOfFundsSavingToast = (containerId: string, toastId: string) => {
    const options = toastOptions(containerId);
    if (toast.isActive(toastId, containerId)) {
        toast.update(toastId, {
            ...options,
            render: 'Saving...',
            type: 'default',
            isLoading: true,
            autoClose: false,
            className: 'auto-save-toast auto-save-toast--saving',
        });
        return;
    }
    toast.loading('Saving...', {
        ...options,
        toastId,
        className: 'auto-save-toast auto-save-toast--saving',
    });
};

export const showFlowOfFundsCycleOutcomeToast = (
    containerId: string,
    toastId: string,
    hasError: boolean,
    hasConflict: boolean,
    savedCount: number
) => {
    const options = toastOptions(containerId);
    if (hasError) {
        toast.update(toastId, {
            ...options,
            type: 'error',
            render: 'Auto-save failed',
            isLoading: false,
            autoClose: false,
            className: 'auto-save-toast auto-save-toast--error',
        });
        return;
    }
    if (hasConflict || savedCount === 0) {
        toast.dismiss(toastId);
        return;
    }
    toast.update(toastId, {
        ...options,
        type: 'success',
        render: '✓ Saved',
        isLoading: false,
        icon: false,
        autoClose: SAVED_TOAST_AUTOCLOSE_MS,
        className: 'auto-save-toast auto-save-toast--success',
    });
};

export interface FlowOfFundsMutationToast {
    saving: () => void;
    saved: () => void;
    failed: () => void;
}

/**
 * One-shot save indicator for a discrete mutation — the whole cycle is a single
 * request, so there is nothing to debounce and no conflict outcome to report.
 */
export const createFlowOfFundsMutationToast = (
    containerId: string,
    toastId: string
): FlowOfFundsMutationToast => ({
    saving: () => showFlowOfFundsSavingToast(containerId, toastId),
    saved: () => showFlowOfFundsCycleOutcomeToast(containerId, toastId, false, false, 1),
    failed: () => showFlowOfFundsCycleOutcomeToast(containerId, toastId, true, false, 0),
});
